import { z } from "zod";

export const cursorSchema = z
  .object({
    hasPreviousPage: z.boolean(),
    hasNextPage: z.boolean(),
    startCursor: z.string().nullable(),
    endCursor: z.string().nullable(),
  })
  .nullable();
